/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./bioMatrixScan.vue?vue&type=template&id=b42c875e&scoped=true"
import script from "./bioMatrixScan.vue?vue&type=script&lang=js"
export * from "./bioMatrixScan.vue?vue&type=script&lang=js"
import style1 from "./bioMatrixScan.vue?vue&type=style&index=1&id=b42c875e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42c875e",
  null
  
)

export default component.exports